import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GraphView from './views/GraphView';
import LevelsView from './views/LevelsView';
import SettingsView from './views/SettingsView';
import WorkoutView from './views/WorkoutView';
import WeightView from './views/WeightView';
import GymView from './views/GymView';
import NavigationBar from './components/NavigationBar';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App" style={{ paddingBottom: 60 }}>
        <Routes>
          <Route path="/" element={<GraphView />} />
          <Route path="/workout" element={<WorkoutView />} />
          <Route path="/levels" element={<LevelsView />} />
          <Route path="/gym" element={<GymView />} />
          <Route path="/weight" element={<WeightView />} />
          <Route path="/settings" element={<SettingsView />} />
        </Routes>
        <NavigationBar />
      </div>
    </Router>
  );
}

export default App;
